import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * props:
 * - to: /settings
 * - text: Settings
 * - variant: 'main' | 'sub'
 * - onClick
 * - className
 */
function SideBarItem(props) {
    const location = useLocation();
    const variant = props.variant || 'main';

    function isActivePath(path) {
        if (path === '/') return location.pathname === '/';
        return location.pathname === path || location.pathname.startsWith(`${path}/`);
    }

    const isActive = isActivePath(props.to);

    const baseClasses = 'sidebar-link flex items-center rounded-lg transition-all duration-200 no-underline text-slate-700 hover:bg-blue-50 hover:text-blue-900';

    const linkClasses = [
        baseClasses,
        variant === 'main' ? 'px-3 py-2.5' : 'px-3 py-2 sidebar-link-sub',
        isActive ? (variant === 'sub' ? 'sidebar-link-active-sub' : 'sidebar-link-active-main') : '',
        props.className || '',
    ].filter(Boolean).join(' ');

    function handleClick(event) {
        event.stopPropagation();
        if (props.onClick) props.onClick(event);
    }

    return (
        <li className="list-none">
            <Link to={props.to} className={linkClasses} onClick={handleClick}>
                <span>{props.text}</span>
            </Link>
        </li>
    );
}

export default SideBarItem;